import {FC, useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import {Modal} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'

const api = new Api()

type Props = {
  showFormModal: boolean
  handleCloseFormModal: any
  formData: any
}

const FormPage: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [dataRole, setDataRole] = useState<any>([])
  const [errors, setErrors] = useState<any>({})

  useEffect(() => {
    setShow(showFormModal)

    if (showFormModal) {
      fetchDataRole()
    }

    if (formData) {
      setFormValue(formData)
    }
  }, [showFormModal])

  const fetchDataRole = (params = {}) => {
    api
      .getRole({...params})
      .then((response: any) => {
        const data = response.data.data
        setDataRole(data)
      })
      .catch((error: any) => {
      })
  }

  const handleInput = (e: any, name: string) => {
    setFormValue({...formValue, [name]: e.target.value})
  }

  const handleClose = () => {
    setFormValue({})
    handleCloseFormModal(false)
    setShow(false)
    setErrors({})
  }

  const store = () => {
    setLoading(true)

    let baseApi
    if (formValue?.id) {
      baseApi = api.updateDetailAssessment(formValue, formValue?.id)
    } else {
      baseApi = api.saveDetailAssessment(formValue)
    }

    baseApi
      .then((response: any) => {
        setLoading(false)
        toast.success(response?.data?.message)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response

        setErrors(data.errors)
      })
  }

  return (
    <Modal show={show} size='lg'>
      <Modal.Header closeButton onHide={handleClose}>
        <Modal.Title>{formValue?.id ? 'Edit' : 'Tambah'} Indikator Penilaian</Modal.Title>
      </Modal.Header>
      <div>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-12'>
              <p>Nama Komponen</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.nama ? 'border-danger' : ''}`}
                value={formValue?.nama}
                onChange={(e) => handleInput(e, 'nama')}
              />

              {errors?.nama ? <p className='text-danger mt-1'>{errors?.nama}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Tipe</p>
              <select
                className={`form-control mt-2 ${errors?.tipe ? 'border-danger' : ''}`}
                value={formValue?.tipe}
                onChange={(e) => handleInput(e, 'tipe')}
              >
                <option value=''>--Pilih Tipe--</option>
                <option value='proposal'>Proposal</option>
                <option value='substansi'>Substansi</option>
              </select>
              {errors?.tipe ? <p className='text-danger mt-1'>{errors?.tipe}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Deskripsi Indikator</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.deskripsi ? 'border-danger' : ''}`}
                value={formValue?.deskripsi}
                onChange={(e) => handleInput(e, 'deskripsi')}
              />

              {errors?.deskripsi ? <p className='text-danger mt-1'>{errors?.deskripsi}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Bobot Kemampuan (%)</p>
              <input
                type='number'
                className={`form-control mt-2 ${errors?.bobot ? 'border-danger' : ''}`}
                value={formValue?.bobot}
                onChange={(e) => handleInput(e, 'bobot')}
              />

              {errors?.bobot ? <p className='text-danger mt-1'>{errors?.bobot}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Tooltip Pilihan 1</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.tooltip_1 ? 'border-danger' : ''}`}
                value={formValue?.tooltip_1}
                onChange={(e) => handleInput(e, 'tooltip_1')}
              />

              {errors?.tooltip_1 ? <p className='text-danger mt-1'>{errors?.tooltip_1}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Tooltip Pilihan 2</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.tooltip_2 ? 'border-danger' : ''}`}
                value={formValue?.tooltip_2}
                onChange={(e) => handleInput(e, 'tooltip_2')}
              />

              {errors?.tooltip_2 ? <p className='text-danger mt-1'>{errors?.tooltip_2}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Tooltip Pilihan 4</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.tooltip_3 ? 'border-danger' : ''}`}
                value={formValue?.tooltip_3}
                onChange={(e) => handleInput(e, 'tooltip_3')}
              />

              {errors?.tooltip_3 ? <p className='text-danger mt-1'>{errors?.tooltip_3}</p> : null}
            </div>

            <div className='col-md-12 mt-5'>
              <p>Tooltip Pilihan 5</p>
              <input
                type='text'
                className={`form-control mt-2 ${errors?.tooltip_4 ? 'border-danger' : ''}`}
                value={formValue?.tooltip_4}
                onChange={(e) => handleInput(e, 'tooltip_4')}
              />

              {errors?.tooltip_4 ? <p className='text-danger mt-1'>{errors?.tooltip_4}</p> : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={handleClose} disabled={loading}>
            Batalkan
          </Button>
          <Button variant='primary' type='button' disabled={loading} onClick={store}>
            {loading ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

const FormModal: FC<Props> = ({showFormModal, handleCloseFormModal, formData}) => {
  return (
    <FormPage
      showFormModal={showFormModal}
      handleCloseFormModal={handleCloseFormModal}
      formData={formData}
    />
  )
}

export default FormModal
